import { Timestamp } from "firebase/firestore";
import { EvaluationTestRun } from "~/classes/models/evaluations/evaluation_test_run.model";

export const useCopyTestToRun = async ({
  evaluationTest,
  evaluationTestRun,
}: {
  evaluationTest: EvaluationTest;
  evaluationTestRun: EvaluationTestRun;
}) => {
  const response = await $fetch(
    `/api/${evaluationTest.originalReportedProblem.documentId}/${evaluationTest.originalReportedProblem.revisionId}/${evaluationTest.originalReportedProblem.checklistCriteriaId}/metric`,
    {
      method: "POST",
      headers: await useApiHeaders(),
      body: {
        metricDataOverride: {
          ...evaluationTestRun.evaluationMetric,
          id: evaluationTestRun.evaluationMetricId,
        },
      },
    }
  );

  evaluationTest.criteriaConfig = {
    cretedAtTimestamp: Timestamp.now(),
    criteria: response,
  };

  return evaluationTest;
};
